import UsersSpamRoute from './UsersSpamRoute';

export default UsersSpamRoute;
